var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pay-trans-details" }, [
    _c(
      "div",
      { staticClass: "filter-section-container" },
      [
        _c("div", { staticClass: "filter-fixed" }, [
          _c("span", { staticClass: "filter-fixed-title" }, [
            _vm._v(_vm._s(_vm.$t("data.filter_section"))),
          ]),
          _c("i", {
            staticClass: "el-icon-arrow-down filter-fixed-arrow",
            class: { "fiter-icon-arrow-route": !_vm.showFilterContent },
            on: { click: _vm.onClickFixedArrow },
          }),
        ]),
        _c("el-collapse-transition", [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showFilterContent,
                  expression: "showFilterContent",
                },
              ],
            },
            [
              _c(
                "div",
                {
                  staticClass: "filter-content",
                  attrs: { id: "filter-content" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "filter-item",
                      class: { "border-red": _vm.isShowBorderRed },
                    },
                    [
                      _c("div", { staticClass: "filter-item-label" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("merchantAccount.complete_time")) +
                            " "
                        ),
                      ]),
                      _c("el-date-picker", {
                        staticClass: "filter-item-value",
                        attrs: {
                          size: "small",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd",
                          type: "daterange",
                          "range-separator": "~",
                          "start-placeholder": _vm.$t("components.start_date"),
                          "end-placeholder": _vm.$t("components.end_date"),
                        },
                        model: {
                          value: _vm.search.return_time,
                          callback: function ($$v) {
                            _vm.$set(_vm.search, "return_time", $$v)
                          },
                          expression: "search.return_time",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "filter-item" },
                    [
                      _c("div", { staticClass: "filter-item-label" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("merchant.merchant_no") +
                                "/" +
                                _vm.$t("merchant.merchant_name")
                            ) +
                            " "
                        ),
                      ]),
                      _c("SearchAgentSelect", {
                        staticStyle: { width: "100%" },
                        model: {
                          value: _vm.search.merchant_name_no,
                          callback: function ($$v) {
                            _vm.$set(_vm.search, "merchant_name_no", $$v)
                          },
                          expression: "search.merchant_name_no",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "filter-item" },
                    [
                      _c("div", { staticClass: "filter-item-label" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("customerService.refund_transaction_status")
                          )
                        ),
                      ]),
                      _c(
                        "el-select",
                        {
                          staticClass: "filter-item-value",
                          attrs: {
                            filterable: "",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.search.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "status", $$v)
                            },
                            expression: "search.status",
                          },
                        },
                        _vm._l(_vm.refundTypeMap, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c("div", { staticClass: "filter-operate" }, [
                _c(
                  "div",
                  { staticClass: "filter-operate-right" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "search-btn mb-10",
                        attrs: { size: "small" },
                        on: { click: _vm.onClickReset },
                      },
                      [_vm._v(_vm._s(_vm.$t("components.clear")))]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "search-btn mb-10",
                        attrs: {
                          type: "primary",
                          size: "small",
                          icon: "el-icon-search",
                        },
                        on: { click: _vm.handleFilter },
                      },
                      [_vm._v(_vm._s(_vm.$t("components.search")))]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]),
      ],
      1
    ),
    _c("div", { staticClass: "total-container" }, [
      _c("div", { staticClass: "total-item" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.$t("customerService.refund_transactions_number_summary")
            ) +
            ": "
        ),
        _c("span", { staticStyle: { color: "#3855F1" } }, [
          _vm._v(_vm._s(_vm.total_count)),
        ]),
      ]),
      _c("div", { staticClass: "total-item" }, [
        _vm._v(
          " " + _vm._s(_vm.$t("customerService.full_refund_summary")) + ": "
        ),
        _c("span", { staticStyle: { color: "#3855F1" } }, [
          _vm._v(
            _vm._s(_vm.$store.getters.currency) +
              " " +
              _vm._s(_vm._f("toDivideWithDot")(_vm.total_amount))
          ),
        ]),
      ]),
      _c("div", { staticClass: "total-item" }, [
        _vm._v(
          " " +
            _vm._s(_vm.$t("customerService.refund_commission_amount_summary")) +
            ": "
        ),
        _c("span", { staticStyle: { color: "#3855F1" } }, [
          _vm._v(
            _vm._s(_vm.$store.getters.currency) +
              " " +
              _vm._s(_vm._f("toDivideWithDot")(_vm.total_fee))
          ),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "tableContainer" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.listLoading,
                expression: "listLoading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData,
              stripe: "",
              fit: "",
              "highlight-current-row": "",
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                "min-width": "110",
                label: _vm.$t("merchant.merchant_name"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [_vm._v(_vm._s(scope.row.merchant_name))]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "min-width": "110",
                label: _vm.$t("customerService.refund_transaction_status"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-tag",
                        {
                          staticClass: "payin-status tag-custom",
                          attrs: {
                            type: _vm.getRefundTypeMapType(scope.row.status),
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.getRefundTypeMap(scope.row.status))
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "min-width": "110",
                label: _vm.$t("data.refund_amount"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(
                              Math.abs(scope.row.this_time_refund_amount)
                            )
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "min-width": "110",
                label: _vm.$t("customerService.refund_commission_amount"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(
                              Math.abs(scope.row.agent_commission)
                            )
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "min-width": "110",
                label: _vm.$t("merchantAccount.complete_time"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(_vm._s(scope.row.transaction_return_time)),
                      ]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-container" },
          [
            !_vm.listLoading
              ? _c("paginator", {
                  attrs: { "list-query": _vm.listQuery },
                  on: { "paginator-change": _vm.onClickPaginator },
                })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }